import { ThemeMode } from '@hotmart/space-lib/dist/styles/themes/enum'
import styled from 'styled-components'

export const ContainerMenuBar = styled.div`
  min-width: 11.75rem;
  box-shadow: 0px 0.5rem 1rem -0.375rem #0000001f;
  height: 2.5rem;
`

ContainerMenuBar.displayName = 'ContainerMenuBar'

export const CustomButton = styled.button<{ $theme: ThemeMode }>`
  background: var(--white);
  padding: var(--spacer-1);
  border: none;
  font-size: 0.875rem;
  cursor: pointer;

  color: ${(props) => (props.$theme === ThemeMode.DARK ? 'var(--gray-100);' : 'var(--gray-900);')}

  width: var(--spacer-6);
  height: var(--spacer-6);

  &:hover {
    background-color: ${(props) =>
      props.$theme === ThemeMode.DARK ? 'var(--gray-800);' : 'var(--gray-200);'}
    border-radius: 0.25rem;
  }
`

CustomButton.displayName = 'CustomButtonMenuBarEditor'

export const Divider = styled.div`
  height: var(--spacer-3);
  border-left: 0.063rem solid var(--gray-200);
  margin: 0px var(--spacer-3);
`

Divider.displayName = 'DividerMenuBarEditor'
